import axios from "axios";
import { toast } from "react-toastify";
// import logger from "./logService";

axios.interceptors.response.use(null, (error) => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

    if (!expectedError) {
        // logger.log(error);
        toast.error("Um erro inesperado ocorreu.");
    } else if (error.response.status === 403) {
        toast.error("User sem permissão para realizar esta requisição.");
    } else if (error.response.status === 401) {
        localStorage.removeItem("token");
        // @ts-ignore
        window.location = "/";
    }

    return Promise.reject(error);
});

function setJwt(jwt) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
}

const http = {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setJwt,
};

export default http;